import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import './assets/main.css'
import InstantSearch from 'vue-instantsearch/vue3/es'
import Antd from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.css'

createApp(App).use(Antd).use(InstantSearch).use(store).use(router).mount('#app')
